function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["aria-live", "aria-relevant", "aria-atomic", "checkedChildren", "className", "disabled", "errorMessage", "errorMessageClassName", "hint", "inversed", "inputClassName", "label", "labelClassName", "requirementLabel", "size", "uncheckedChildren", "inputRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import EvEmitter from 'ev-emitter';
import FormLabel from '../FormLabel/FormLabel';
import React from 'react';
import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
/** Used to emit events to all Choice components */
var dsChoiceEmitter = new EvEmitter();

/**
 * This component passes any additional props to its underlying input element
 * as attributes. See the corresponding MDN documentation for
 * [input](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input) for
 * a list of valid attributes.

 * For information about how and when to use this component, refer to the
 * [checkbox](https://design.cms.gov/components/checkbox/) and
 * [radio](https://design.cms.gov/components/radio/) documentation pages.
 */
export var Choice = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Choice, _React$PureComponent);
  var _super = _createSuper(Choice);
  function Choice(props) {
    var _this$props$id;
    var _this;
    _classCallCheck(this, Choice);
    _this = _super.call(this, props);
    _this.input = null;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleUncheck = _this.handleUncheck.bind(_assertThisInitialized(_this));
    _this.id = (_this$props$id = _this.props.id) !== null && _this$props$id !== void 0 ? _this$props$id : uniqueId('choice--');
    if (typeof _this.props.checked === 'undefined') {
      _this.isControlled = false;
      // Since this isn't a controlled component, we need a way
      // to track when the value has changed. This can then be used
      // to identify when to toggle the visibility of (un)checkedChildren
      _this.state = {
        checked: _this.props.defaultChecked
      };
    } else {
      _this.isControlled = true;
    }
    return _this;
  }
  _createClass(Choice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Event emitters are only relevant for uncontrolled radio buttons
      if (!this.isControlled && this.props.type === 'radio') {
        this.uncheckEventName = "".concat(this.props.name, "-uncheck");
        dsChoiceEmitter.on(this.uncheckEventName, this.handleUncheck);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Unbind event emitters are only relevant for uncontrolled radio buttons
      if (!this.isControlled && this.props.type === 'radio') {
        dsChoiceEmitter.off(this.uncheckEventName, this.handleUncheck);
      }
    }
  }, {
    key: "checked",
    value: function checked() {
      if (this.isControlled) {
        return this.props.checked;
      }
      return this.state.checked;
    }

    /**
     * A radio button doesn't receive an onChange event when it is unchecked,
     * so we fire an "uncheck" event when any radio option is selected. This
     * allows us to check each radio options' checked state.
     * @param {String} checkedId - ID of the checked radio option
     */
  }, {
    key: "handleUncheck",
    value: function handleUncheck(checkedId) {
      if (checkedId !== this.id && this.input.checked !== this.state.checked) {
        this.setState({
          checked: this.input.checked
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(evt) {
      if (this.props.onChange) {
        this.props.onChange(evt);
      }
      if (!this.isControlled) {
        this.setState({
          checked: evt.target.checked
        });
        if (this.props.type === 'radio' && evt.target.checked) {
          // Emit the uncheck event so other radio options update their state
          dsChoiceEmitter.emitEvent(this.uncheckEventName, [this.id]);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        ariaLive = _this$props['aria-live'],
        ariaRelevant = _this$props['aria-relevant'],
        ariaAtomic = _this$props['aria-atomic'],
        checkedChildren = _this$props.checkedChildren,
        className = _this$props.className,
        disabled = _this$props.disabled,
        errorMessage = _this$props.errorMessage,
        errorMessageClassName = _this$props.errorMessageClassName,
        hint = _this$props.hint,
        inversed = _this$props.inversed,
        inputClassName = _this$props.inputClassName,
        label = _this$props.label,
        labelClassName = _this$props.labelClassName,
        requirementLabel = _this$props.requirementLabel,
        size = _this$props.size,
        uncheckedChildren = _this$props.uncheckedChildren,
        inputRef = _this$props.inputRef,
        inputProps = _objectWithoutProperties(_this$props, _excluded);
      var inputClasses = classNames(inputClassName, 'ds-c-choice', {
        'ds-c-choice--inverse': inversed,
        'ds-c-choice--small': size === 'small'
      });

      // Remove props we have our own implementations for
      if (inputProps.id) delete inputProps.id;
      if (inputProps.onChange) delete inputProps.onChange;
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        "aria-live": ariaLive !== null && ariaLive !== void 0 ? ariaLive : checkedChildren ? 'polite' : null,
        "aria-relevant": ariaRelevant !== null && ariaRelevant !== void 0 ? ariaRelevant : checkedChildren ? 'additions text' : null,
        "aria-atomic": ariaAtomic !== null && ariaAtomic !== void 0 ? ariaAtomic : checkedChildren ? 'false' : null
      }, /*#__PURE__*/React.createElement("div", {
        className: "ds-c-choice-wrapper"
      }, /*#__PURE__*/React.createElement("input", _extends({
        className: inputClasses,
        id: this.id,
        onChange: this.handleChange,
        disabled: disabled,
        ref: function ref(_ref) {
          _this2.input = _ref;
          if (inputRef) {
            inputRef(_ref);
          }
        }
      }, inputProps)), /*#__PURE__*/React.createElement(FormLabel, {
        className: labelClassName,
        fieldId: this.id,
        errorMessage: errorMessage,
        errorMessageClassName: errorMessageClassName,
        hint: hint,
        inversed: inversed,
        requirementLabel: requirementLabel
      }, label)), this.checked() ? checkedChildren : uncheckedChildren);
    }
  }]);
  return Choice;
}(React.PureComponent);
export default Choice;